import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { QualityControlMessage } from './shared/QualityControlMessage';
import { BaseMessage } from './BaseMessage';

export const StartArticleRepairTaskMessage = () => {
  const { article, iam } = useArticleContext();
  const isLastQualityControlKO = article.steps?.findLast(
    (step) => step.status === 'cancelled' && step.step === 'quality-control'
  );

  if (!iam.hasUserScopeOnArticle('workshop')) {
    return (
      <BaseMessage
        title={
          <Trans id="article.task.start-article-repair.on-behalf.title">
            Workshop repair required
          </Trans>
        }
        message={
          <Trans id="article.task.start-article-repair.on-behalf.message">
            Please contact the workshop to validate the repair job on its behalf.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.task.start-article-repair.title">Start the repair</Trans>}
      message={
        <Stack gap="0.25rem">
          <p>
            <Trans id="article.task.start-article-repair.message">
              Please click on the &quot;Start repair&quot; button below. This will start the
              indicated repair time.
            </Trans>
          </p>
          {isLastQualityControlKO && <QualityControlMessage article={article} />}
        </Stack>
      }
      article={article}
    />
  );
};
